angular.module('bmsApp.settings')
	.factory('MMOnlineProductSvc', function ($http, $log, $window, $q, CRUDSvc, PRODUCT_API) {

		return {
			index: function (params) {
				return CRUDSvc.get(PRODUCT_API.INDEX, params);
			},
			save: function (data) {
				return CRUDSvc.create(PRODUCT_API.SAVE, data);
			},
			options: function (data) {
				return CRUDSvc.get(PRODUCT_API.OPTIONS, data);
			},

		}

	})
	.constant('PRODUCT_API', {
		INDEX: 'api/mm/product/index',
		SAVE: 'api/mm/products/save',
		OPTIONS: 'api/mm/product/type/options'
	});

